module.exports = __webpack_public_path__ + "img/member_idcard_image1.0da44ca0.png";